import { CellProps } from 'react-table'
import { PlainHeader, sortableColumn, StackedCell, TableColumn } from '../../../../../../components'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { TFunction } from '_metronic/i18n/Metronici18n'
import { AtendimentoGestao } from '../../core/_models'

export const atendimentoGestaoColumns = (
  t: TFunction
): ReadonlyArray<TableColumn<AtendimentoGestao>> => [
  // Coluna do botão de expandir (o ModernTable desenha o botão na coluna de id `expand`).
  {
    Header: () => <span className='visually-hidden'>Detalhes</span>,
    id: 'expand',
    cellWidth: '56px',
  },
  // Paciente com o protocolo como apoio; os dois seguem ordenáveis.
  sortableColumn<AtendimentoGestao>({
    id: 'paciente.pessoa.nome',
    useQueryRequest,
    fields: [
      { field: 'paciente.pessoa.nome', label: t('cols.paciente') },
      { field: 'protocolo', label: t('cols.protocolo') },
    ],
    Cell: ({ row }: CellProps<AtendimentoGestao>) => (
      <StackedCell
        primary={row.original.paciente?.pessoa?.nome || row.original.paciente?.nome}
        secondary={row.original.protocolo}
      />
    ),
  }),
  sortableColumn<AtendimentoGestao>({
    id: 'especialidade.nome',
    cellWidth: '180px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'especialidade.nome', label: t('cols.especialidade') }],
    Cell: ({ row }: CellProps<AtendimentoGestao>) => (
      <StackedCell primary={row.original.especialidade?.nome} />
    ),
  }),
  sortableColumn<AtendimentoGestao>({
    id: 'estado.nome',
    cellWidth: '160px',
    useQueryRequest,
    fields: [{ field: 'estado.nome', label: t('cols.status') }],
    Cell: ({ row }: CellProps<AtendimentoGestao>) => (
      <StackedCell primary={row.original.estado?.nome} />
    ),
  }),
  sortableColumn<AtendimentoGestao>({
    id: 'solicitacao',
    cellWidth: '160px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'solicitacao', label: t('cols.agendamento') }],
    Cell: ({ row }: CellProps<AtendimentoGestao>) => (
      <StackedCell tabular primary={row.original.solicitacaoFormatada} />
    ),
  }),
  // Término em destaque (ordem padrão: mais recente primeiro); início como apoio.
  sortableColumn<AtendimentoGestao>({
    id: 'termino',
    cellWidth: '200px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [
      { field: 'termino', label: 'Término' },
      { field: 'inicio', label: 'Início' },
    ],
    Cell: ({ row }: CellProps<AtendimentoGestao>) => (
      <StackedCell
        tabular
        primary={row.original.terminoFormatado}
        secondary={row.original.inicioFormatado}
      />
    ),
  }),
  // Retorno em texto (antes era só um ponto colorido: cor não pode ser o único significado).
  {
    Header: () => <PlainHeader>{t('cols.retorno')}</PlainHeader>,
    id: 'retorno',
    cellWidth: '96px',
    Cell: ({ row }: CellProps<AtendimentoGestao>) => (
      <StackedCell primary={row.original.retorno ? 'Sim' : 'Não'} />
    ),
  },
]
